export default {
      id: "eye-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#eye",
      toString: function () {
        return this.url;
      }
    }